import {
  Button,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { formatPreparingTime, formatValue } from "../../../../utils/genral-functions";
import "./DeliveryOptionsBtns.scss";
import axios from "axios";
import moment from "moment";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../redux-store/store";

const   DeliveryOptionsBtns = (props) => {
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch()
  const {setDeliveryDateTimePopup} = bindActionCreators (actionCreators, appDispatch)
  const { data, availableTime, setAvailableTime, expanded, setExpanded, stopAsapBtn, preparingTime } = props;

  const [isInRange, setIsInRange] = useState(false);


const handleClickDeliveryOptions = (name) => {
  if(name == "asap"){
    setExpanded(name)
    setDeliveryDateTimePopup(false)
  }
  else{
    setExpanded(name)
    setDeliveryDateTimePopup(true)

  }
}


  console.log(stopAsapBtn ? false : appState.storeInfo?.deliveryAsap, 'Asap btn')
  const [deliveryOptionsList, setDeliveryOptionsList] = useState([
    { show:  stopAsapBtn ? false : appState.storeInfo?.deliveryAsap,
      title: "Delivery ASAP",
      description: "",
      icon: <AccessTimeIcon />,
      name: "asap",
    },
    { show:  false,
      title: "Delivery Later Today",
      description: "Book the order, deliver it later",
      icon: <DeliveryDiningIcon />,
    },
    { show:  appState.storeInfo?.deliveryShecheduled,
      title: "Schedule",
      description:  availableTime?.showDecidedTime || "Book delivery for a specific date and time",
      icon: <CalendarTodayIcon />,
      name: "later",
    },

  ]);

    useEffect(() => {
      setDeliveryOptionsList(prev => prev.map(item => (item.name == 'asap' ? { ...item, show: stopAsapBtn ? false : item.show } : item  )))
    }, [stopAsapBtn])
    
  return (
    <section id="deliveryOptionsBtns" className="row m-0 py-2">
      <div className="col-12 p-0 d-flex justify-content-evenly align-items-center">
        {deliveryOptionsList.map((item, index) => (
         item.show && <Button  disabled={expanded == item.name } variant={expanded == item.name ? "contained" : "outlined"}  className={`${(index==0 && !(preparingTime > 0)) ? `btn-padding22`: `btn-padding5`} flex-column z mx-1 ${expanded == item.name ? "option-btn-active" : "optionsBtn"}`} onClick={() => handleClickDeliveryOptions(item.name)}  style={{direction: 'ltr'}}>
          <span>{item.icon}         {t(`${item.title}`)} </span>
          {(item.name == 'asap' && preparingTime > 0) && <span className={`show-time-content`}>{formatPreparingTime(preparingTime, t)}</span>}

         { (availableTime?.showDecidedTime && index==2) ? <span className={`show-time-content`}>{availableTime?.showDecidedTime}</span> : index ==2 ? <span > {t(`Pick Time and Date`)} </span> :<span>  </span> }
       </Button>
        ))}
      </div>
    </section>
  );
};

export default DeliveryOptionsBtns;
